export const manifest = {
  screens: {
    scr_xojbz0: { name: "Home", route: "/", position: {"x":0,"y":0}, isDefaultRow: true },
    scr_skloef: { name: "Individual Therapy", route: "/therapy/individual", position: {"x":160,"y":1820} },
  },
  sections: {
    sec_u1d81q: { name: "Therapy Services", x: 0, y: 1600, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "screen", id: "scr_xojbz0" },
    { kind: "section", id: "sec_u1d81q", children: [
      { kind: "screen", id: "scr_skloef" },
    ] },
  ],
}
